// extracted by mini-css-extract-plugin
export default {"container":"ir-z","heading":"jr-z","text":"kr-z","info":"lr-z","link":"mr-z","fullMaxWidth":"nr-z"};